import * as SeparatorPrimitive from "@radix-ui/react-separator";
import * as React from "react";

import { cn } from "@/lib/utils.ts";

export const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>
>(({ className, orientation = "horizontal", decorative = true, ...props }, ref) => (
  <SeparatorPrimitive.Root
    ref={ref}
    decorative={decorative}
    orientation={orientation}
    className={cn(
      "shrink-0 bg-border",
      orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
      className,
    )}
    {...props}
  />
));
Separator.displayName = SeparatorPrimitive.Root.displayName;

/**
 * Renders a separator line with content, used for special messages in the feed.
 *
 * BBL custom component
 */
export const LabelSeparator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>
>(({ children, ...props }, ref) => {
  return (
    <div className="flex justify-center items-center text-muted-foreground" ref={ref} {...props}>
      <Separator className="flex-1" />
      <span className="px-3 font-medium text-xs whitespace-nowrap flex items-center gap-0.5">
        {children}
      </span>
      <Separator className="flex-1" />
    </div>
  );
});
LabelSeparator.displayName = "LabelSeparator";
